export default __webpack_public_path__ + "static/media/card2@3x.7fd2d0d0.png";